import { useLingui } from "@lingui/react/macro";
import type { FC } from "react";

const Area: FC<{ value: number }> = ({ value }) => {
  const { i18n } = useLingui();
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      {i18n.number(value / 1000000, {
        style: "unit",
        unit: "kilometer",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
      <sup>2</sup>
    </span>
  );
};
export default Area;
